import "./TableCard.scss";
import ColorSchema from "../../components/kits/Color/index.tsx";
export default function TableCard({
  column,
  widthParent,
  bg,
  showSelect,
  content,
}) {
  // console.log("con", content);
  const selectColor = (bg) => {
    switch (bg) {
      case "primary_light_custom":
        return ColorSchema.primary_custom;
        break;
      case "secondary_light_custom":
        return ColorSchema.secondary_custom;
        break;
      case "success_light_custom":
        return ColorSchema.success_custom;
        break;
      case "danger_light_custom":
        return ColorSchema.danger_custom;
        break;
      case "warning_light_custom":
        return ColorSchema.warning_custom;
        break;
      case "info_light_custom":
        return ColorSchema.info_custom;
        break;
      case "dark_light_custom":
        return ColorSchema.dark_custom;
        break;
      default:
        return ColorSchema.white_custom;
        break;
    }
  };
  const selectbg = (bg) => {
    switch (bg) {
      case "pink_custom":
        return ColorSchema.pink_custom;
        break;
      case "primary_custom":
        return ColorSchema.primary_custom;
        break;
      case "secondary_custom":
        return ColorSchema.secondary_custom;
        break;
      case "success_custom":
        return ColorSchema.success_custom;
        break;
      case "danger_custom":
        return ColorSchema.danger_custom;
        break;
      case "warning_custom":
        return ColorSchema.warning_custom;
        break;
      case "info_custom":
        return ColorSchema.info_custom;
        break;
      case "dark_custom":
        return ColorSchema.dark_custom;
        break;
      case "primary_light_custom":
        return ColorSchema.primary_light_custom;
        break;
      case "secondary_light_custom":
        return ColorSchema.secondary_light_custom;
        break;
      case "success_light_custom":
        return ColorSchema.success_light_custom;
        break;
      case "danger_light_custom":
        return ColorSchema.danger_light_custom;
        break;
      case "warning_light_custom":
        return ColorSchema.warning_light_custom;
        break;
      case "info_light_custom":
        return ColorSchema.info_light_custom;
        break;
      case "dark_light_custom":
        return ColorSchema.dark_light_custom;
        break;
      case "navy_custom":
        return ColorSchema.navy_custom;
        break;
      case "orange_custom":
        return ColorSchema.orange_custom;
        break;
      case "blue_custom":
        return ColorSchema.blue_custom;
        break;
      case "red_custom":
        return ColorSchema.red_custom;
        break;
      default:
        return ColorSchema.primary_custom;
        break;
    }
  };
  return (
    <div className="p-card ">
      <div
        style={{
          width: widthParent,
          backgroundColor: selectbg(bg),
          borderRight: `1px solid ${selectColor(bg)}`,
          borderBottom: `1px solid ${selectColor(bg)}`,
        }}
        className={`d-flex  flex-wrap card-tbl  mt-4 `}
      >
        {showSelect == "true" && (
          <div
            className="d-flex-column"
            style={{ borderLeft: `1px solid  ${selectColor(bg)}` }}
          >
            <div
              className="txt"
              style={{
                borderBottom: `1px solid  ${selectColor(bg)}`,
                color: selectColor(bg),
                borderTop: `1px solid ${selectColor(bg)}`,
              }}
            >
              {" "}
              انتخاب
            </div>
            <div className="txt" style={{}}>
              <input className="mx-auto" type="checkbox"></input>
            </div>
          </div>
        )}

        {column.map((value, index) => {
          return (
            <div
              className={` ${
                value.type == "img"
                  ? "col-img"
                  : value.type == "title"
                  ? "col-title"
                  : value.type == "description"
                  ? "col-desc"
                  : value.type == "operation"
                  ? "col-operation"
                  : value.type == "statistics"
                  ? "col-statistics"
                  : ""
              }`}
              style={{
                borderLeft: `1px solid  ${selectColor(bg)}`,
                flexGrow: "1",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className="txt"
                style={{
                  borderBottom: `1px solid  ${selectColor(bg)}`,
                  color: selectColor(bg),
                  borderTop: `1px solid ${selectColor(bg)}`,
                }}
              >
                {value.title}
              </div>
              <div
                style={{
                  flexGrow: "1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className={`txt_content ${
                    value.type == "description" ? "box-over" : ""
                  }`}
                  style={{
                    color: selectColor(bg),
                  }}
                >
                  {content[value.name] ? content[value.name] : "---"}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
